import i18next from "i18next";
import notificationActions from "../flux/actions/NotificationActions";

class TriggerNotifications {
  public async success(messages: string[]) {
    if (messages && messages.length) {
      messages.forEach(async (item: any) => {
        await notificationActions.show({
          severity: "success",
          message: i18next.t(item),
        });
      });
    }
  }

  public async info(message: string) {
    await notificationActions.show({
      severity: "info",
      message: i18next.t(message),
    });
  }

  public async error(message: string) {
    await notificationActions.show({
      severity: "alarm",
      message: i18next.t(message),
    });
  }

  public async errors(messages: string[], data?: any) {
    if (messages && messages?.length) {
      messages?.forEach(async (item: any) => {
        await notificationActions.show({
          severity: "alarm",
          message: i18next.t(`${item} ${(data != null || data != undefined) ? ':' + data : ''}`),
          data: data,
        });
      });
    }
  }
}

const triggerNotifications = new TriggerNotifications();
export default triggerNotifications;
